import React from 'react';

const TimeCompContext = React.createContext({minutes: 0, seconds: 10});

export default TimeCompContext;